import { render, staticRenderFns } from "./LaudoSupressaoVegetalRedYellowFlag.vue?vue&type=template&id=32234fde&scoped=true&lang=pug"
import script from "./LaudoSupressaoVegetalRedYellowFlag.vue?vue&type=script&lang=js"
export * from "./LaudoSupressaoVegetalRedYellowFlag.vue?vue&type=script&lang=js"
import style0 from "./LaudoSupressaoVegetalRedYellowFlag.vue?vue&type=style&index=0&id=32234fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32234fde",
  null
  
)

export default component.exports